import { t } from 'i18next'

import { SortDebugValue } from '@wwt/core/admin'
import { Feature, FeatureOptions } from '@wwt/entities/search-response'
import { capitalizeFirstLetter } from '@wwt/shared/utils/capitalizeFirstLetter.ts'

import { NO_NAME } from '@/shared/config/NO_NAME'

// TODO: Refactor
export const getFeatureLabel = (
	selectedOption: FeatureOptions,
	feature: Feature,
	showSelectedOption?: boolean,
	showFeatureName?: boolean
) => {
	if (!showSelectedOption && !showFeatureName) {
		return (
			<>
				{'-'}: {'-'}
			</>
		)
	}

	const FeaturePriorityDebug = () => (
		<SortDebugValue
			integrationPriority={feature.integrationPriority}
			wwtPriority={feature.wwtPriority}
		/>
	)

	const OptionPriorityDebug = () => (
		<SortDebugValue
			integrationPriority={selectedOption.integrationPriority}
			wwtPriority={selectedOption.wwtPriority}
		/>
	)

	if (showSelectedOption) {
		if (showFeatureName) {
			if (selectedOption.name !== NO_NAME) {
				return (
					<>
						<span>{capitalizeFirstLetter(feature.name)}</span>
						<FeaturePriorityDebug />

						<span>{': '}</span>
						<span>{capitalizeFirstLetter(selectedOption.name)}</span>

						<OptionPriorityDebug />
					</>
				)
			}

			// We don't show option if option name is NO_NAME
			return (
				<>
					<span>{capitalizeFirstLetter(feature.name)}</span>
					<FeaturePriorityDebug />
				</>
			)
		}

		if (selectedOption.name !== NO_NAME) {
			return (
				<>
					<span>{capitalizeFirstLetter(selectedOption.name)}</span>
					<OptionPriorityDebug />
				</>
			)
		}

		return t('option.noName', { ns: 'translation' })
	}

	return (
		<>
			<span>{capitalizeFirstLetter(feature.name)}</span>
			<FeaturePriorityDebug />
		</>
	)
}
